import {type FlexProps} from '@sanity/ui'

export const FLEX_GAP: FlexProps['gap'] = 3
